import api from '@/core/apiclient'
import {actionTypes} from '@/core/constants'

export default {
    async [actionTypes.FUNDO_ESPECIAL.BUSCAR_FUNDOS](context, orgaoId) {
        const {data} = await api.fundoEspecial.buscarFundos(orgaoId)
        return data
    }
}
